import type { IMessageBase } from './base';

export const MESSAGE_TYPE = 'ADDROUTE_ZIPRELATIVEPATH';

export interface IMessageZipRelativePathResponderPayload extends IMessageBase {
    type: 'ADDROUTE_ZIPRELATIVEPATH';
    payload: {
        zipPath: string;
        relativeRespondPath: string;
    };
}
